/**
 * Toggle the visibility of the dropdown content.
 *
 * @param {HTMLElement} button - The button element that triggers the dropdown.
 */
function toggleDropdown(button) {
  const dropdownContent = button.nextElementSibling;
  dropdownContent.classList.toggle('show');
}

document.addEventListener('DOMContentLoaded', function initializeDropdowns() {
  const dropdownButtons = document.querySelectorAll('.dropbtn');

  dropdownButtons.forEach(function addClickListener(button) {
    button.addEventListener('click', function handleButtonClick() {
      toggleDropdown(this);
    });
  });

  window.onclick = function handleWindowClick(event) {
    if (!event.target.matches('.dropbtn')) {
      const dropdowns = document.getElementsByClassName('dropdown-content');
      let i;
      for (i = 0; i < dropdowns.length; i++) {
        const openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  };
});
